/*
 * Simplified for party-only fork — LWA auth only, no CBL/MAP/TV.
 */

import { globalRef } from '@amzn/vinyl-util'
import { type Auth, AuthStatus } from '@/auth/auth'
import type { AuthTokenProvider } from '@amzn/vinyl-amzn'
import { LwaAuth } from '@/auth/LwaAuth'
import { type ObservableValue } from '@amzn/vinyl-observable'

export const authRef = globalRef<Auth>(() => new LwaAuth())

export function getAuth(): Auth {
    return authRef.value
}

export function getTokenProvider(): AuthTokenProvider {
    return authRef.value.authTokenProvider
}

export function getAuthToken(): Promise<string> {
    return authRef.value.authTokenProvider()
}

export const signedIn: () => ObservableValue<boolean> = () =>
    getAuth().status.map((v) => v === AuthStatus.SIGNED_IN)

export const notSignedIn: () => ObservableValue<boolean> = () =>
    getAuth().status.map((v) => v !== AuthStatus.SIGNED_IN)

let sessionId: string | null = null

export function getAnonSessionId(): string {
    if (!sessionId) {
        const part1 = Math.floor(Math.random() * 1e3).toString().padStart(3, '0')
        const part2 = Math.floor(Math.random() * 1e7).toString().padStart(7, '0')
        const part3 = Math.floor(Math.random() * 1e7).toString().padStart(7, '0')
        sessionId = `${part1}-${part2}-${part3}`
    }
    return sessionId
}
